import { connect } from 'react-redux'
import GeneratedLicenseManagement from '../../components/GeneratedLicenses/GeneratedLicenseManagement'
import {getAllLicenses} from "../../actions/index";


const mapStateToProps = state => {
    return {
        userName: state.auth.username,
        data: state.license.allLicenses
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getAllLicenses : () => {
            return dispatch(getAllLicenses());
        }

    }

};


export default connect(
    mapStateToProps,
    mapDispatchToProps

)(GeneratedLicenseManagement);
